import { defineStore } from 'pinia';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const useDeviceStore = defineStore('device', {
    state: () => ({
        fingerprint: null
    }),

    actions: {
        async init() {
            if (this.fingerprint) return;

            const fp = await FingerprintJS.load();
            const result = await fp.get();

            this.fingerprint = result.visitorId;
        }
    }
});